import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { setIsShowBonusPriceDialog } from '../../../actions/dialog';
import BonusPriceDialog from '../../../components/Dialog/bonusPriceDialog';
import s from '../../../assets/styles/style.sass';
import s2 from '../../order/Order.sass';
import modelDataTextEN from '../../../assets/src/scripts/gogovan/order/hk/en-hk.json';
import { returnLocaleText } from '../../../service/util';
import { updateOrderDetailInfoAction } from '../../../actions/order';

const tips = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
const tips2 = [0, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
class OrderSummary11Fee extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    orderPriceBreakdownDetail: PropTypes.shape().isRequired,
    modelDataText: PropTypes.shape().isRequired,
    setIsShowBonusPriceDialog: PropTypes.func.isRequired,
    updateOrderDetailInfoAction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectFee: 0,
      lang: props.currentLocale.split('-')[1].toLowerCase(),
      isKorea: ['kr'].includes(props.currentLocale.split('-')[1].toLowerCase()),
      price: props.orderPriceBreakdownDetail.total,
    };
  }

  getTips() {
    if (this.state.lang === 'tw') {
      return tips.map(x => x * 2);
    } else if (this.state.lang === 'sg') {
      return tips.map(x => x / 5);
    } else if (this.state.lang === 'kr') {
      return tips2.map(x => x * 200);
    }
    return tips;
  }

  render() {
    return (
      <div>
        <div className={s2.fee}>
          <p className={s2.orderSmallTitle}>
            {this.props.modelDataText.order_summary_charge_title}
          </p>
          <hr className={s2.hrBottom} />
          <span>
            {typeof this.props.orderPriceBreakdownDetail.breakdown !==
            'undefined'
              ? Object.keys(this.props.orderPriceBreakdownDetail.breakdown).map(
                  (v, index) => (
                    <div key={index.toString()}>
                      <span>
                        {
                          this.props.orderPriceBreakdownDetail.breakdown[v]
                            .title
                        }
                      </span>
                      <span className={s2.right}>
                        {typeof this.props.orderPriceBreakdownDetail.breakdown[
                          v
                        ].value === 'number'
                          ? !this.state.isKorea
                            ? `${this.props.modelDataText.dollar_code} ${
                                this.props.orderPriceBreakdownDetail.breakdown[
                                  v
                                ].value
                              }`
                            : `${
                                this.props.orderPriceBreakdownDetail.breakdown[
                                  v
                                ].value
                              } ${this.props.modelDataText.dollar_code}`
                          : ''}
                      </span>
                    </div>
                  ),
                )
              : ''}
          </span>
          <div className={`${s.sectionOrderPrice}`} style={{ float: 'left' }}>
            <span style={{ paddingTop: '8px' }}>
              {returnLocaleText(
                this.props.modelDataText.order_summary_charge_tips,
                modelDataTextEN.order.order_summary_charge_tips,
              )}
            </span>
            <span
              className={`${s2.functionText} ${s.globalTextBlue}`}
              style={{ fontSize: '12px', cursor: 'pointer' }}
              tabIndex={0}
              role="button"
              onClick={() => {
                this.props.setIsShowBonusPriceDialog();
              }}
              onKeyPress={() => {}}
            >
              {returnLocaleText(
                this.props.modelDataText.order_summary_charge_why_tips_button,
                modelDataTextEN.order.order_summary_charge_why_tips_button,
              )}
            </span>
          </div>
          <span className={s.orderPricingBonusPrice} style={{ float: 'right' }}>
            <select
              className={`${s2.inputSelect} ${s2.backgroundDark} ${
                s2.simpleSelectDropdown
              } ${s2.icon} col-12`}
              style={{ paddingRight: '5px' }}
              onChange={e => {
                this.setState({
                  selectFee: parseInt(e.target.value, 10),
                });
                this.props.updateOrderDetailInfoAction(
                  'bonus',
                  null,
                  parseInt(e.target.value, 10),
                );
              }}
            >
              {this.getTips().map(i => (
                <option value={i} key={i}>
                  {this.state.isKorea
                    ? `${i} ${this.props.modelDataText.dollar_code}`
                    : `${this.props.modelDataText.dollar_code} ${i}`}
                </option>
              ))}
            </select>
          </span>
        </div>

        <br />
        <br />
        <div className={s2.orderPricingRow}>
          <hr style={{ border: '1px solid #000', marginTop: 0 }} />
          <Row>
            <Col className={s2.orderPricingTotal}>
              <span>{this.props.modelDataText.price_total_amount}</span>
            </Col>
            <Col className={s2.orderPricingTotalPrice}>
              <span>
                {this.state.isKorea ? '' : this.props.modelDataText.dollar_code}
                {this.state.price + this.state.selectFee}
                {this.state.isKorea ? this.props.modelDataText.dollar_code : ''}
              </span>
            </Col>
          </Row>
        </div>

        <br />
        <br />
        <p className={s.globalTextRed}>
          <small>
            {returnLocaleText(
              this.props.modelDataText.order_summary_payment_message,
              modelDataTextEN.order.order_summary_payment_message,
            )}
          </small>
        </p>
        <small>
          <a href="/pricing" target="blank" className={s.globalTextBlue}>
            {returnLocaleText(
              this.props.modelDataText.order_summary_payment_price_table_button,
              modelDataTextEN.order.order_summary_payment_price_table_button,
            )}
          </a>
        </small>
        <BonusPriceDialog />
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  address: state.order.address,
  remark: state.order.remark,
  passengerCount: state.order.passenger_count,
  tunnel: state.order.tunnel,
  images: state.order.images,
  vehicle: state.order.vehicle,
  pickupTime: state.order.pickup_time,
  orderPriceBreakdownDetail: state.order.orderPriceBreakdownDetail,
  orderDetailInfo: state.order.orderDetailInfo,
});
const mapDispatch = {
  setIsShowBonusPriceDialog,
  updateOrderDetailInfoAction,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(OrderSummary11Fee),
);



// WEBPACK FOOTER //
// ./src/routes/OrderSummary/OrderSummary11Fee/OrderSummary11Fee.js